import { useState, useRef } from "react";
import apiRequest from "../../../utils/apiRequest";

export const displayName = (user) =>
  [user.name, user.lastname].filter(Boolean).join(" ") || user.email;

const useAssignments = ({ cta, website, canAssign }) => {
  const [assigned, setAssigned] = useState([]);
  const [pool, setPool] = useState([]);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const loaded = useRef(false);

  const baseUrl = `/websites/${website.id}/cta/${cta.id}/assignments`;

  async function loadAssignments() {
    setLoading(true);
    const result = await apiRequest("GET", baseUrl);
    if (result.code === 200 && result.json) {
      setAssigned(result.json.assigned || []);
      setPool(result.json.assignable || []);
      loaded.current = true;
    }
    setLoading(false);
  }

  const isAssigned = (userId) => assigned.some((u) => u.id === userId);

  const usersById = new Map();
  pool.forEach((user) => usersById.set(user.id, user));
  assigned.forEach((user) => usersById.set(user.id, user));

  const filteredUsers = Array.from(usersById.values())
    .filter((user) =>
      displayName(user).toLowerCase().includes(query.trim().toLowerCase())
    )
    .sort((a, b) => {
      const aAssigned = isAssigned(a.id);
      const bAssigned = isAssigned(b.id);
      if (aAssigned !== bAssigned) return aAssigned ? -1 : 1;
      return displayName(a).localeCompare(displayName(b));
    });

  async function toggle(user) {
    if (!canAssign) return;

    const wasAssigned = isAssigned(user.id);
    if (wasAssigned) {
      setAssigned((prev) => prev.filter((u) => u.id !== user.id));
    } else {
      setAssigned((prev) => [...prev, user]);
    }

    const result = wasAssigned
      ? await apiRequest("DELETE", `${baseUrl}/${user.id}`)
      : await apiRequest("POST", baseUrl, { user_id: user.id });

    const ok = result && result.code >= 200 && result.code < 300;
    if (!ok) {
      if (wasAssigned) {
        setAssigned((prev) => [...prev, user]);
      } else {
        setAssigned((prev) => prev.filter((u) => u.id !== user.id));
      }
    }
  }

  return {
    assigned,
    pool,
    loading,
    query,
    setQuery,
    filteredUsers,
    usersById,
    isAssigned,
    toggle,
    loadAssignments,
    loaded,
  };
};

export default useAssignments;
